import React, { useState } from 'react';
import {
    Route as ReactRouterRoute,
    Routes as ReactRouterRoutes,
} from 'react-router-dom';
import { Route } from '../../../../types';
import { DPage } from '../../../dum';
import { SUpsertOrderSale } from '../../../smart';
import { OrderSalesPage } from './order-sales/order-sales-page';
import { DFab } from '../../../dum/simple/button/d-fab';

const productsPages: Route[] = [
    {
        name: 'OrderSalesPage',
        path: '/',
        component: <OrderSalesPage />,
        title: 'Ventas',
        navbar: false,
    },
];

export function OrderSalesHomePage() {
    const [orderSaleUpsertDialog, setOrderSaleUpsertDialog] = useState(false);

    return (
        <DPage>
            <DFab
                onClick={() => {
                    setOrderSaleUpsertDialog(true);
                }}
            />
            <ReactRouterRoutes>
                {productsPages.map((page, index) => {
                    return (
                        <ReactRouterRoute
                            path={page.path}
                            element={page.component}
                            key={index}
                        />
                    );
                })}
            </ReactRouterRoutes>
            <SUpsertOrderSale
                open={orderSaleUpsertDialog}
                setOpen={setOrderSaleUpsertDialog}
            />
        </DPage>
    );
}
